<h1 class="app-title">{{ 'app.name' | translate }}</h1>
